import { DisplayUtils } from '../../../utils';
import './Pagination.scss'

const Pagination = ({ page, totalPages, onPageChange }) => {

  return (
    <nav className="paginations" aria-label="Paginación">
        <button
            type="button"
            onClick={() => page > 0 && onPageChange(page - 1)}
            className="pagination_button me-3"
            disabled={page <= 0}
        >
            <span className="sr-only">Anterior</span>
            <img src={DisplayUtils.isMobile() ? '/misc/icons/chevron_left_white.svg' : '/misc/icons/chevron_left_white.svg'} alt='icon-left' />
        </button>
        <span className="pageAll" aria-live="polite">
            Página <strong>{page+1}</strong> de {totalPages === 1 ? 1 : totalPages}
        </span>
        <button
            type="button"
            onClick={() => page < totalPages-1 && onPageChange(page + 1)}
            className="pagination_button ms-3"
            disabled={page >= totalPages - 1}
        >
            <span className="sr-only">Siguiente</span>
            <img src={DisplayUtils.isMobile() ? '/misc/icons/chevron_right_white.svg' : '/misc/icons/chevron_right_white.svg'} alt='icon-right' />
        </button>
    </nav>
  );
};

export default Pagination;